import { render, staticRenderFns } from "./ActasAdministrativasForm.vue?vue&type=template&id=238fa2fe"
import script from "./ActasAdministrativasForm.vue?vue&type=script&lang=js"
export * from "./ActasAdministrativasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports